import React from 'react';
import './Header.css';

function Header() {
    return (
        <header className="header">
            N O M I K A I W A
        </header>
    );
}

export default Header;
